export default __webpack_public_path__ + "static/media/miInspectionLogo_transp.ae88fbf6.png";